import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EditorialIntelligenceService } from 'src/app/services/editorial-intelligence-service';

/**
 * "Import reference links" panel — paste URLs, optional notes, a suggested-use,
 * and import them as manual references (metadata + rights auto-extracted server
 * side). Presentational + one service call; emits `imported` so the host page can
 * refresh its dossier/media. Dev-only editorial workflow; no publishing.
 */
@Component({
  selector: 'pla-editorial-import-panel',
  templateUrl: './editorial-import-panel.component.html',
  styleUrls: ['./editorial-import-panel.component.scss'],
})
export class EditorialImportPanelComponent {
  @Input() registration = '';
  @Output() imported = new EventEmitter<void>();

  public urlsText = '';
  public notes = '';
  public suggestedUse = 'source_citation';
  public readonly uses = [
    'hero', 'inline_image', 'video', 'source_citation',
    'background_reference', 'social_embed', 'unknown',
  ];

  public importing = false;
  public result: any = null;

  constructor(private intel: EditorialIntelligenceService) {}

  public get urlList(): string[] {
    return (this.urlsText || '')
      .split(/\r?\n/)
      .map((u) => u.trim())
      .filter((u) => !!u);
  }

  public runImport(): void {
    const urls = this.urlList;
    if (!urls.length || !this.registration || this.importing) return;
    this.importing = true;
    this.result = null;
    this.intel
      .importReferences(this.registration, urls, this.notes, this.suggestedUse)
      .subscribe(
        (res) => {
          this.importing = false;
          this.result = res;
          if (res && res.status === 'completed') {
            this.imported.emit(); // let the host refresh the dossier/media
          }
        },
        () => {
          this.importing = false;
          this.result = { status: 'error', detail: 'Import failed.' };
        }
      );
  }

  public rightsClass(status?: string): string {
    switch (status) {
      case 'platex_owned':
      case 'public_domain':
        return 'ok';
      case 'embed_only':
        return 'info';
      case 'permission_required':
      case 'licence_required':
        return 'warn';
      default:
        return 'muted';
    }
  }
}
